import { Component, OnInit, ErrorHandler } from '@angular/core';
//import { AdataService } from '../../shared/adata.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { getLocaleDateFormat } from '@angular/common';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-agent-creations',
  templateUrl: './agent-creations.component.html',
  styleUrls: ['./agent-creations.component.css']
})
export class AgentCreationsComponent implements OnInit {

  title = "Pigmy Agent Creation";
  // constructor() { }
cc:any={};
  data: any = {};
  formInvalid: boolean = false;
  p: any ={};
  a: any = {};
  aa: any = {};
  intro:any={};
  AGENT_ID: number;
  ACC_ID: number;
  CUSTID: number;
  mode: string;  
  AccNolist: any = {}
  Branchlist: any = {}
  Designationlist: any = {}
  Custlist: any;
  intoducerlist: any;
  CustomerDetails: any;
  AgentNamelist: any = {}
  fileToUpload: File = null;
  hide: boolean = false;
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  agepattern = "[1-100]";
  Accountnum = "/^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/";
  today: Date;
  cusId : string;
  custdxt:any;
  branchset:any={};
  custdoc:any;
  agentcode:any;
  Documents: any;
  agentaddress: any;
  agremtdoc: any;
  agentagrmtdocurl: any;

  
  constructor(private Service: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
  ) { }
  ngOnInit() {   
   
    this.p.L_DATE= new Date().toISOString().split('T')[0];
    //  this.p.L_DATE = this.today;
        //  = (Date().split('T'))[0];
    // this.p.L_DATE=date.now()
    this.GetAllData();
    //this.GetCode();

    this.route.params.subscribe(params => {
      
      this.AGENT_ID = params['AGENT_ID'];
      this.mode = params['mode'];

      if (this.AGENT_ID > 0) {
        this.GetPigmyById(this.AGENT_ID)
      }
      if (this.mode == 'View') {
        this.hide = true;

      }
    });

    if (this.mode == 'view') {
      this.title = "View Pigmy Agent Creation";
    }
    else if (this.mode == 'edit') {
      this.title = "Edit Pigmy Agent Creation";
    }


  }
  GetAllData() {
    debugger
    let BRANCH_ID=localStorage.getItem('BRANCH_ID');
    //ddl for branch  
    this.data = this.Service.GetAllBranch();
    this.data.subscribe(
      (response: any) => {
        this.Branchlist=response;
        for(let i=0;i<response.length;i++){
           if(BRANCH_ID==response[i].BRANCH_ID){
             this.branchset=response[i]
            // this.Branchlist.push();
           }
         }
         this.Branchlist=Array.of(this.branchset);
         this.p.BRANCH_ID=BRANCH_ID;
      })
    //ddl for designation
    this.data = this.Service.GetAllDesignation();
    this.data.subscribe(
      (response: any) => {
        this.Designationlist = response;
        console.log(this.Designationlist);
        

      })

    //ddl for cust
    this.data = this.Service.GetAllCust();
    this.data.subscribe(
      (response: any) => {
        this.Custlist = response;
        this.intoducerlist=response;
        console.log('Cus');
        console.log(this.Custlist)
      })

  }

 
  GetDetails(CUSTID,CUSNAME){


   
    this.cc.searchText=CUSTID;
    this.cusId = this.cc.searchText;
    this.cc.searchName=CUSNAME;
 
    // this.p.AGENT_add=data.AGENT_add;
    // this.p.AGENT_add1=data.AGENT_add1;
    
    this.GetAgentName(CUSTID);
    this.GetAccNo(CUSTID)
    // this.ExitCUstId(CUSTID)
    this.CustomerDetails=[];



    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.Service.ExitCUstId(CUSTID);
    this.data.subscribe(
      (response) => {
        console.log('Output');
        console.log(response);
        if(response == 'Customer Id already exist'){
          swal("Warning!", "This Agent Alredy Exist", "warning");
          document.getElementById('loader-spinner').style.display = "none";
          this.cc={};
          return;
       
        }     
      
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        console.log(error);
       
        swal("Warning!", "This Agent Alredy Exist", "warning");
        this.clear()
      });




  }
  GetCustomerDetails(SearchValue: any, SearchName: any,BRANCH_ID) {    
   debugger;
    if (SearchValue == "" && SearchName == "") {
        this.CustomerDetails = null;
        return
    }
    if (SearchValue == "" || SearchValue == undefined) { SearchValue = "empty" } if (SearchName == "" || SearchName == undefined) { SearchName = "empty" }
    this.Service.GetCustomerDetails(SearchValue, SearchName,BRANCH_ID)
        .subscribe(
            (data: any) => {
                this.CustomerDetails = data;
                // this.p.AGENT_add=data.
                console.log(data);
            }, (error) => {
                this.errorHandler.handleError(error);
            });
}
getaddanddoc(custid)
{
  this.custdxt=this.Service.getadddoc(custid);
  this.custdxt.subscribe(
    (custresponse:any)=>{
      console.log(custresponse);
      this.p.AGENT_add=custresponse.ANAME;
      this.p.AGENT_add1=custresponse.DIS_ADD;
    }
  )
}
getadoc(custid)
{
  this.custdoc=this.Service.getdoc(custid);
  this.custdoc.subscribe(
    (custresponse:any)=>{
      console.log(custresponse);
      this.p.AGENT_Doc=custresponse.DESC_LL;
      this.p.AGENT_Doc_num=custresponse.LINKNO;
    }
  )
}
    
 GetAgentName (CUSTID) {
  debugger;
    this.data = this.Service.GetAgentName(CUSTID);
    this.data.subscribe(
      (response: any) => {
        this.p.AGENT_DESC = response.AGENT_DESC;
        this.p.AGENT_CONTACT= response.AGENT_CONTACT;
        this.Documents=response.DocumentModelsList;
        this.agentaddress=response.address;
        //this.getaddanddoc(CUSTID);
        this.getadoc(CUSTID);
      })
  }


  // ExitCUstId(CUSTID){
  //   debugger;
  //   this.data = this.Service.ExitCUstId(CUSTID);
  //   this.data.subscribe(
  //     (response: any) => {

  //       this.p.CUSTID = response.CUSTID;

  //       swal('Warning!', 'This Customer Alredy Exist.', 'warning');
  //     })
  // }

  // ExitCUstId(CUSTID){
  //   debugger;
  //   alert(CUSTID);
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.Service.ExitCUstId(CUSTID);
  //   this.data.subscribe(
  //     (response) => {
  //       console.log('Output');
  //       console.log(response);
  //       if(response == 'Customer Id already exist'){
  //         swal("Warning!", "This Customer Alredy Exist", "warning");
  //         document.getElementById('loader-spinner').style.display = "none";
  //         return;
  //       }
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       console.log(error);
       
  //       swal("Warning!", "This Customer Alredy Exist", "warning");
       
  //     });
  // }
  //geting code
  GetCode() {
    debugger
    let agcode;
    this.data = this.Service.GetCode();
    this.data.subscribe(
      (response: any) => {
        //this.p.AGENT_CODE = response.AGENT_CODE;
        this.agentcode=response; 
        console.log("Agent Code");
        console.log(response.AGENT_CODE);
      })
  }

  GetAccNo(CUSTID) {
    debugger;
    this.data = this.Service.GetAccNo(CUSTID);
    this.data.subscribe(
      (response: any) => {
        // this.p.AC_NO = response.AC_NO;
        this.AccNolist = response;
      })

     // this.p.ACC_ID = this.AccNolist[0].ACC_ID;
  }
  SavePigmy(Pigmy: NgForm) {
   
    if(Pigmy.value.searchText==undefined)
    {
      this.searchTextempty=true;
      swal("Warning!", "Please enter the Customer Id", "warning");
    }
    else
    {
    Pigmy.value.CUSTID=Pigmy.value.searchText;
    Pigmy.value.AGENT_DESC=Pigmy.value.searchName
       debugger;
    console.log('Pigmy Forms');
    console.log(Pigmy.value);
    if(Pigmy.value.AGENT_SUP==undefined)
      Pigmy.value.AGENT_SUP=0;
    if(Pigmy.value.Type_ag==undefined)
       Pigmy.value.Type_ag=0;
    if(Pigmy.value.Designationid==undefined)
       Pigmy.value.Designationid=0;
    if(Pigmy.value.Introducer==undefined)
       Pigmy.value.Introducer=0;
    Pigmy.value.agrmtdoc=this.agntdoc();
       


    debugger;
    //this.agentcode=
    this.GetCode();
    Pigmy.value.AGENT_CODE=this.agentcode;
   // if (Pigmy.invalid) {
     // this.formInvalid = true;
    //  swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    //  return;
   // }

   // else {
      console.log('Data');
      console.log(Pigmy.value);     
    this.data = this.Service.PostPigmy(Pigmy.value);
    this.data.subscribe(
      (response) => {
        Pigmy.reset();
        Pigmy.resetForm();
        Pigmy.form.markAsPristine();
        Pigmy.form.markAsUntouched();
        swal('Success!', 'Pigmy Agent Added Successfully, Agent Id is:'+this.agentcode, 'success');
        this.router.navigate(['/home/UnicoreMaster1/PigmyAgent']);
        // document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        // document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
           swal('Warning!', error.error.Message, 'warning');
        }
        else
        {
          swal('Error! Something went wrong','Error: '+error,'error');
        }
      });

  //  }
    }
      
  }

  GetPigmyById(AGENT_ID) {
  
    debugger;
   this. GetAllData() ;
    // document.getElementById('loader-spinner').style.display = "block";
    this.data = this.Service.GetPigmyById(AGENT_ID);
    this.data.subscribe(
      (response: any) => {
        this.cc.searchText=response.CUSTID;
        this.cc.searchName=response.AGENT_DESC;
        this.p = response;
        this.GetAgentName(response.CUSTID);
        this.GetAccNo(response.CUSTID);
        this.p.AGENT_add= response.ANAME;
        this.p.AGENT_add1=response.DIS_ADD;
        this.setsuperior(response.Type_ag,"intro");
       // this.p.Designationid=
         this.setdesignation(response.Designationid);
        this.p.Type_ag=response.AGENT_TYPE;
        this.setsuperior(response.AGENT_SUP,"superior");
        console.log('Get By Id');
        console.log();
        console.log(response);
        //this.AGENT_add
        //for date displaying in view

        if (this.p.L_DATE != null)
        this.p.L_DATE = ((this.p.L_DATE).split('T'))[0];
        this.agentagrmtdocurl=response.agrmtdocpath;
        



        // document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        // document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          // swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  UpdatePigmy(Pigmy: NgForm) {
    debugger;
    // this.CalculateAge(Fir.value.Fir_Infmnt_Age)
    // {
    //   return false;
    // }
    // this.CUSTID=Pigmy.value.cc.CUSTID;
    // Pigmy.value.CUSNAME=Pigmy.value.cc.CUSNAME;
    
    Pigmy.value.AGENT_DESC=this.cc.searchName;
    Pigmy.value.CUSTID=this.cusId;

    Pigmy.value.AGENT_ID = this.AGENT_ID;
    Pigmy.value.CUSTID=Pigmy.value.searchText;
    Pigmy.value.AGENT_DESC=Pigmy.value.searchName;
    document.getElementById('loader-spinner').style.display = "block";
    console.log('Pigmy value');
    console.log(Pigmy.value);

    this.data = this.Service.UpdatePigmy(Pigmy.value, this.AGENT_ID);
    this.data.subscribe(
      (response) => {
        // Pigmy.value.CUSTID=this.cc.searchText;
        // Pigmy.value.CUSNAME=this.cc.searchName;
        Pigmy.reset();
        Pigmy.resetForm();
        Pigmy.form.markAsPristine();
        Pigmy.form.markAsUntouched();
        document.getElementById('loader-spinner').style.display = "none";
        swal('Success!', 'Pigmy Agent updated Successfully .', 'success');
        // document.getElementById('loader-spinner').style.display = "none";
        // this.router.navigate(['/home/fir/']);
        this.router.navigate(['/home/UnicoreMaster1/PigmyAgent']);
      }, (error) => {
        // document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          // swal('Warning!', error.error.Message, 'warning');
        }
      });

  } 

  clear()
  {
    this.cc.CUSTID='';
    this.cc.CUSNAME='';
  }
  Cancel() { 
    this.p.L_DATE='';
    this.p.BRANCH_ID='';
    this.p.CUSTID='';
    this.p.AGENT_DESC='';
    this.p.AGENT_CONTACT='';
    this.p.AGENT_SUP='';
    this.p.AC_NO='';
    this.p.AGENT_DESG='';
    this.p.Type_ag='';
  }

  setsuperior(id:any,field:any )
  {
   
 
    this.data = this.Service.GetAllCust();
    this.data.subscribe(
      (response: any) => {
  console.log(response);
        for(let i=0;i<response.length;i++){
          if(id==response[i].AGENT_ID){
            if(field=="superior")
            {
             
            //  this.p.Type_ag=response[i].AGENT_ID;
            }
            if(field=="promo")
            {
           
              this.p.AGENT_SUP=response[i].AGENT_ID;
            }
            if(field=="intro")
            {
           
              this.p.Introducer=response[i].AGENT_ID;
            }
            
           
          }
        }
      })

  }

  setdesignation(id)
  {
    debugger;
    this.data = this.Service.GetAllDesignation();
    this.data.subscribe(
      (response: any) => {
        console.log(response);
        for(let i=0;i<response.length;i++){
          if(id==response[i].AGENT_DESG){
            debugger;
            this.p.Designationid=response[i].AGENT_DESG;
          }
        }

      })
  }
  FileInputForProfDocumnet(file: FileList) 
  {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdf)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.agremtdoc = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.Service.agreemntdocupload(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('agrmtdoc');
          //i.value="";
           if (error.status == 400) {
             this.agremtdoc = "assets/images/image-default.png";
             swal('Warning!', error.error.Message, 'warning');
           }
        });
    }
    else {
      let i: any = document.getElementById('agrmtdoc');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extensionś pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  agntdoc() {
    let imagename = null;
    try {
      imagename = document.getElementById('agrmtdoc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  searchTextempty:boolean=false
  Referencefilled()
  {
    this.searchTextempty=false;
  }
  }













// WEBPACK FOOTER //
// ./src/app/unicore-masters/agent-creations/agent-creations.component.ts